import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center px-4 py-20">
        <div className="text-center max-w-md">
          <div className="mb-6">
            <AlertCircle className="w-24 h-24 text-red-500 mx-auto mb-4" />
            <h1 className="text-6xl font-extrabold text-gray-900 mb-2">404</h1>
            <p className="text-2xl font-bold text-red-600">Halaman Tidak Ditemukan</p>
          </div>
          
          <p className="text-gray-600 mb-8 text-lg">
            Maaf, halaman yang Anda cari tidak tersedia. Silahkan kembali ke beranda atau jelajahi website kami.
          </p>

          <div className="flex gap-4 flex-col sm:flex-row justify-center">
            <button
              onClick={() => navigate('/')}
              className="px-6 py-3 bg-brand text-navy font-semibold rounded-full hover:bg-brand-dark transition-colors"
            >
              Kembali ke Beranda
            </button>
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-3 bg-gray-200 text-gray-900 font-semibold rounded-full hover:bg-gray-300 transition-colors"
            >
              Kembali
            </button>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-300">
            <p className="text-gray-500 text-sm mb-4">Status: 404 Not Found</p>
            <p className="text-gray-600 text-xs mb-6">
              Coba jelajahi halaman lain:
            </p>
            <div className="flex flex-wrap gap-3 justify-center">
              <Link to="/" className="text-blue-600 hover:text-blue-800 text-sm">
                Beranda
              </Link>
              <Link to="/about" className="text-blue-600 hover:text-blue-800 text-sm">
                Tentang Kami
              </Link>
              <Link to="/products" className="text-blue-600 hover:text-blue-800 text-sm">
                Produk
              </Link>
              <Link to="/blog" className="text-blue-600 hover:text-blue-800 text-sm">
                Blog
              </Link>
              <Link to="/contact" className="text-blue-600 hover:text-blue-800 text-sm">
                Kontak
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
